import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useState } from 'react';
import EditableDescription from '@/components/editable-description';

const tips = [
  {
    title: 'Dagelijkse Routine',
    description: 'Begin elke dag met een moment van mindfulness',
    extraInfo:
      'Een vaste routine helpt je om meer structuur en rust in je dag te brengen. Begin bijvoorbeeld met 5 minuten ademhalingsoefeningen direct na het opstaan.',
    imageUrl:
      'https://images.unsplash.com/photo-1506126613408-eca07ce68773?q=80&w=1200',
  },
  {
    title: 'Werk-Rust Balans',
    description: 'Neem regelmatig korte pauzes tijdens je werk',
    extraInfo:
      'De 20-20-20 regel: Kijk elke 20 minuten, 20 seconden naar iets dat 20 meter ver weg is. Dit helpt je ogen en geest te ontspannen.',
    imageUrl:
      'https://images.unsplash.com/photo-1552196563-55cd4e45efb3?q=80&w=1200',
  },
  {
    title: 'Gezonde Leefstijl',
    description: 'Beweeg dagelijks en eet gevarieerd',
    imageUrl:
      'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?q=80&w=1200',
  },
];

export default function AlgemeneTipsPage() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showExtra, setShowExtra] = useState<number | null>(null);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % tips.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + tips.length) % tips.length);
  };

  return (
    <div className="min-h-screen p-8 space-y-8">
      <h1 className="text-2xl font-semibold mb-8">Algemene Tips</h1>

      <div className="max-w-4xl">
        <EditableDescription
          pageKey="algemene-tips"
          defaultText="Algemene tips voor een gezonde werk-privé balans en persoonlijk welzijn"
          className="text-lg mb-8"
        />

        <div className="relative">
          <Card className="overflow-hidden">
            <div className="relative aspect-[16/9]">
              <img
                src={tips[currentIndex].imageUrl}
                alt={tips[currentIndex].title}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-black/40 flex items-center justify-center text-center p-6">
                <div className="text-white">
                  <h2 className="text-3xl font-bold mb-4">
                    {tips[currentIndex].title}
                  </h2>
                  <p className="text-xl mb-6">
                    {tips[currentIndex].description}
                  </p>
                  {tips[currentIndex].extraInfo && (
                    <Button
                      variant="outline"
                      className="bg-green-600 border-white text-white hover:bg-green-700"
                      onClick={() => setShowExtra(currentIndex)}
                    >
                      Draai de kaart voor meer info
                    </Button>
                  )}
                </div>
              </div>
            </div>
            {showExtra === currentIndex && tips[currentIndex].extraInfo && (
              <div className="p-6 bg-green-600 text-white">
                <p className="text-lg">{tips[currentIndex].extraInfo}</p>
                <Button
                  variant="outline"
                  className="mt-4 bg-green-600 border-white text-white hover:bg-green-700"
                  onClick={() => setShowExtra(null)}
                >
                  Terug
                </Button>
              </div>
            )}
          </Card>

          <Button
            variant="outline"
            className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white"
            onClick={prevSlide}
          >
            <ChevronLeft className="h-6 w-6" />
          </Button>

          <Button
            variant="outline"
            className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white"
            onClick={nextSlide}
          >
            <ChevronRight className="h-6 w-6" />
          </Button>
        </div>
      </div>
    </div>
  );
}
